import { render, staticRenderFns } from "./RelHeader.vue?vue&type=template&id=1754c150"
import script from "./RelHeader.vue?vue&type=script&lang=js"
export * from "./RelHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports